import { createSlice } from "@reduxjs/toolkit";

export const helpTopicSlice = createSlice({
  name: "helpTopic",
  initialState: {
    getHelpTopicResult: false,
    getHelpTopicLoading: false,
    getHelpTopicError: false,
    addHelpTopicResult: false,
    addHelpTopicLoading: false,
    deleteHelpTopicResult: false,
  },
  reducers: {
    helpTopicReducers: (state, action) => {
      const { type, payload } = action.payload;
      switch (type) {
        case "GET_HELPTOPIC":
          return {
            ...state,
            getHelpTopicResult: payload.data,
            getHelpTopicLoading: payload.loading,
            getHelpTopicError: payload.error,
          };
        case "ADD_HELPTOPIC":
          return {
            ...state,
            addHelpTopicResult: payload.data,
            addHelpTopicLoading: payload.loading,
          };
        case "DELETE_HELPTOPIC":
          return {
            ...state,
            deleteHelpTopicResult: payload.data,
          };
        default:
          return state;
      }
    },
  },
});

export const { helpTopicReducers } = helpTopicSlice.actions;
export default helpTopicSlice.reducer;
